import { styled } from "@mui/material/styles";
import { Menu } from "@mui/material";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: 220,
    marginTop: 8,
    boxShadow: "2px 2px 5px 0 #00000030",
    borderRadius: 4,
  },
  "& .MuiList-root": {
    padding: "24px 0",
  },
  "& .MuiMenuItem-root:hover": {
    color: theme.palette.primary.main,
    background: "transparent",
  },
  "& .MuiMenuItem-root:not(:last-child)": {
    padding: "10px 16px",
  },
}));
